import { createBrowserRouter } from 'react-router-dom';
import { Login } from './pages/auth/Login';
import { StudentDashboard } from './pages/student/StudentDashboard';
import { AdventureEntryPage } from './pages/student/AdventureEntryPage';
import { WritingWorkspace } from './pages/student/WritingWorkspace';
import { AdventureWorkspace } from './pages/student/AdventureWorkspace';
import { AdventurePeerGalleryPage } from './pages/student/AdventurePeerGalleryPage';
import { TeacherDashboard } from './pages/teacher/TeacherDashboard';
import { TeacherDangerImagesPage } from './pages/teacher/TeacherDangerImagesPage';
import { TeacherEscapeImagesPage } from './pages/teacher/TeacherEscapeImagesPage';
import { TeacherMedalsPage } from './pages/teacher/TeacherMedalsPage';
import { TeacherAiAnalyticsPage } from './pages/teacher/TeacherAiAnalyticsPage';
import { TeacherAnalyticsPage } from './pages/teacher/TeacherAnalyticsPage';
import { TeacherPreparationPostersPage } from './pages/teacher/TeacherPreparationPostersPage';
import { PrivateRoute } from './components/common/PrivateRoute';
import App from './App';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/teacher/login',
    element: <Login />,
  },
  {
    path: '/student/login',
    element: <Login />,
  },
  {
    path: '/',
    element: <PrivateRoute><App /></PrivateRoute>,
  },
  {
    path: '/student',
    element: (
      <PrivateRoute roles={['STUDENT']}>
        <StudentDashboard />
      </PrivateRoute>
    ),
  },
  {
    path: '/student/adventure-entry/:assignmentId',
    element: (
      <PrivateRoute roles={['STUDENT']}>
        <AdventureEntryPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/student/write/:assignmentId',
    element: (
      <PrivateRoute roles={['STUDENT']}>
        <WritingWorkspace />
      </PrivateRoute>
    ),
  },
  {
    path: '/student/adventure/:assignmentId',
    element: (
      <PrivateRoute roles={['STUDENT']}>
        <AdventureWorkspace />
      </PrivateRoute>
    ),
  },
  {
    path: '/student/adventure/:assignmentId/gallery/:workType',
    element: (
      <PrivateRoute roles={['STUDENT']}>
        <AdventurePeerGalleryPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/teacher',
    element: (
      <PrivateRoute roles={['TEACHER', 'ADMIN']}>
        <TeacherDashboard />
      </PrivateRoute>
    ),
  },
  {
    path: '/teacher/preparation-posters',
    element: (
      <PrivateRoute roles={['TEACHER', 'ADMIN']}>
        <TeacherPreparationPostersPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/teacher/medals',
    element: (
      <PrivateRoute roles={['TEACHER', 'ADMIN']}>
        <TeacherMedalsPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/teacher/danger-images',
    element: (
      <PrivateRoute roles={['TEACHER', 'ADMIN']}>
        <TeacherDangerImagesPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/teacher/escape-images',
    element: (
      <PrivateRoute roles={['TEACHER', 'ADMIN']}>
        <TeacherEscapeImagesPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/teacher/analytics',
    element: (
      <PrivateRoute roles={['TEACHER', 'ADMIN']}>
        <TeacherAnalyticsPage />
      </PrivateRoute>
    ),
  },
  {
    path: '/teacher/ai-analytics',
    element: (
      <PrivateRoute roles={['TEACHER', 'ADMIN']}>
        <TeacherAiAnalyticsPage />
      </PrivateRoute>
    ),
  },
  {
    path: '*',
    element: <Login />,
  },
]);
